import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router, NavigationEnd, NavigationStart, NavigationError, ActivatedRoute, NavigationCancel, Params } from '@angular/router';
import { FormControl, FormGroup, NgForm } from '@angular/forms';
import { Globals } from 'src/app/globals';
import { DatePipe } from '@angular/common';
import { KycMarutiJourneyService } from '../kyc-maruti-journey/kyc-maruti-journey.service';
import { KycSearchResponse } from '../kyc-hyperverge/kyc-hyperverge.model';
import { Observable, Subscription, interval } from 'rxjs';
import { map } from 'rxjs/internal/operators/map';
import { KycSearchRequest } from '../kyc-maruti-journey/kyc-maruti-journey-model';
@Component({
  selector: 'ckyc-maruti-documents',
  templateUrl: './ckyc-documents.component.html',
  styleUrls: ['./ckyc-documents.component.css']
})
export class CkycDocumentsComponent implements OnInit {

  errMsg: string = "";
  backURL: string = "";
  dateOfBirthDoi: any;
  showValidationMsgs: boolean = false;
  isLoading: boolean;
  public currentDate = new Date();
  @ViewChild('ckycmarutiDocumentsForm') ckycmarutiDocumentsForm: any;
  isKycSuccess: boolean = false;
  isKycFailed: boolean = false;
  kycSearchRequest: KycSearchRequest = new KycSearchRequest();
  kycSearchResponse: KycSearchResponse = new KycSearchResponse();
  $counter: Observable<number>;
  diff: number;
  future: Date;
  stopCountdown: boolean = false;
  subscription: Subscription;
  message: string;
  showPartnerportal :boolean = false;
  identifierOrg: string;
  identifier: string;
  linkDetails: any;

  constructor(private route: ActivatedRoute, public router: Router, public globals: Globals, public datePipe: DatePipe, public kycMarutiJourneyService: KycMarutiJourneyService) {
    this.kycSearchRequest = new KycSearchRequest();
    this.kycSearchResponse = new KycSearchResponse();
  }

  ngOnInit() {
    this.route.queryParams.subscribe(
      (params: Params) => {
        if (params['identifier']) {
          this.identifierOrg = params['identifier'];
          this.identifier = atob(params['identifier']);
        }
      }
    );
    if(this.identifier) {
      this.linkDetails = JSON.parse(this.identifier);
      this.kycSearchRequest.uniqueId  = this.linkDetails.uniqueId;
      this.kycSearchRequest.customerType = this.linkDetails.customerType;
      this.kycSearchRequest.appName = this.linkDetails.appName;
      this.kycSearchRequest.returnURL = this.linkDetails.returnUrl;
      this.kycSearchRequest.kycReferenceNo = this.linkDetails.kycReferenceNo;
    }
  }

  ckycmarutiDocumentsSubmit(ckycmarutiDocumentsForm: NgForm, isValid) {
    if (!isValid) {
      this.showValidationMsgs = true;
      this.validateAllFields(ckycmarutiDocumentsForm.form);
    } else {
      this.isLoading = true;
      this.kycMarutiJourneyService.searchDownloadDefaultKYCDetails(this.kycSearchRequest).subscribe((data: any) => {
        this.isLoading = false;
        this.kycSearchResponse = JSON.parse(JSON.stringify(data));
        if(this.kycSearchResponse && this.kycSearchResponse.kycStatus) {
          this.isKycSuccess = true;
          this.isKycFailed = false;
        } else {
          this.isKycSuccess = false;
          this.isKycFailed = true;
        } 
        if(this.kycSearchRequest.uniqueId && this.kycSearchRequest.uniqueId.substring(0,3).startsWith('KY3')){
          this.showPartnerportal = true;
        } else {
          this.showPartnerportal = false;
        }
        if(this.isKycSuccess) {
          this.message = "5s";
          this.stopCountdown = false;
          this.startCountdown();
        }
      })
    }
  }

  validateAllFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFields(control);
      }
    });
  }

  keyPressNumbers(event) {
    var charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  lettersOnly(event) {
    var k;
    k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32);
  }

  public parseDateFormat(value): void {
    if (value) {
      let formattedDate: string = this.datePipe.transform(value, 'dd/MM/yyyy');
      this.kycSearchRequest.dob_doi = formattedDate;
      console.log(formattedDate);
    }
  }

  backToverificationPage() {
    this.router.navigate(['/kyc-maruti'], { queryParams: { 'identifier': this.identifierOrg } });
  }

  backToPartnerPortal(){
    //this.isLoading = true;
    window.location.href = this.kycSearchResponse.returnURL;
  }

  startCountdown() {
    var d1 = new Date(),
    d2 = new Date(d1);
    d2.setSeconds(d1.getSeconds() + 12);

    this.future = d2;
    //console.log(this.future.getTime()+"***"+new Date().getTime())
    if (this.stopCountdown == false) {
      this.$counter = interval(1000).pipe(
        map((x) => {
          if (this.stopCountdown == false) {
            this.diff = Math.floor((this.future.getTime() - new Date().getTime()) / 1000);
          }
          //console.log(this.diff);
          //console.log(this.diff>0);
          if (this.diff > 0) {
            this.stopCountdown = false;
            return x;
          }
          else {
            this.stopCountdown = true;
            this.subscription.unsubscribe();
            if(this.kycSearchResponse.uniqueId && this.kycSearchResponse.uniqueId.substring(0,3).startsWith('KY3') && this.isKycSuccess){
              this.isLoading = true;
              window.location.href = this.kycSearchResponse.returnURL;
            }
          }

        }));
      if (this.stopCountdown == false) {
        this.subscription = this.$counter
          .subscribe((x) => this.message = this.dhms(this.diff));
      }
    }
  }

  dhms(t) {
    let days, hours, minutes, seconds;
    seconds = t;
    if (this.stopCountdown == false) {
      return [
        seconds + 's'
      ].join(' ');
    }
  }

  resetFields(value){
    this.kycSearchRequest.aadhaarNumber = "";
    this.kycSearchRequest.panNumber = "";
    this.kycSearchRequest.dob_doi = "";
    this.kycSearchRequest.customerName = "";
    this.kycSearchRequest.gender = "";
  }
}